
@if(inputData.data?.remorque){
<h2 mat-dialog-title>{{ "ETABLIR UNE ASSURANCE POUR LA REMORQUE : "+inputData.title |  uppercase }}</h2>
}@else {
  <h2 mat-dialog-title>{{ 'Etablir une assurance pour le vehicule : '+inputData.title |  uppercase }}</h2>
}
<mat-dialog-content class="loading-table-container" id="modalDialog" #modalDialog>
  @if (loading) {
    <div class="loading-table-shade">
      <mat-spinner diameter="70" color="primary"></mat-spinner>
    </div>
  }
<form [formGroup]="assuranceForm" class="p-0 m-0">

    <div class="form-content mat-elevation-z3 m-0 p-3">
      <div class="row">
        @if(inputData.data?.remorque){
          <div class="col col-md-6 row">
            <h3 class="title" >Vehicule Tracteur</h3>
            <div class="col-12">
                <mat-form-field appearance="outline" >
                  <mat-label>Energie</mat-label>
                  <mat-select formControlName="energie">
                    <mat-option disabled="">Choisir une zone.</mat-option>
                    @for (item of energies; track $index) {<mat-option [value]="item">{{ item }}</mat-option>}
                  </mat-select>
                  @if (assuranceForm.get('energie')?.hasError('required')) {<mat-error>Requis</mat-error>}
                </mat-form-field>
                <mat-form-field appearance="outline" disabled >
                  <mat-label>Puissance (CV)</mat-label>
                  <input
                  matInput
                  formControlName="puissance"
                  type="number"
                  >
                  @if (assuranceForm.get('puissance')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  @if (assuranceForm.get('puissance')?.hasError('min')) {<mat-error>puissance superieur a 0</mat-error>}
                </mat-form-field>
                <mat-form-field appearance="outline" disabled >
                  <mat-label>Cylindree</mat-label>
                  <input
                  matInput
                  formControlName="cylindree"
                  type="number"
                  >
                  @if (assuranceForm.get('cylindree')?.hasError('min')) {<mat-error>cylindree superieur a 0</mat-error>}
                </mat-form-field>
            </div>
          </div>
        }
        <div class="col col-md-6 row">
          <h3 class="title" >Document</h3>
          <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" disabled >
                <mat-label>Compagnie</mat-label>
                <input
                matInput
                readonly
                formControlName="compagnie_name"
                type="text"
                #inputCompanie>
                <button matButton matSuffix
                  [color]="(this.assuranceForm.get('compagnie_name')?.value=='')?'warn':'primary'"
                  (click)="selectCompagnie()"
                  matTooltip="selectionner">
                  <mat-icon >ink_selection</mat-icon>
                </button>
                @if (assuranceForm.get('compagnie_id')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>
              <mat-form-field appearance="outline" >
                <mat-label>Zone</mat-label>
                <mat-select formControlName="zone">
                  <mat-option disabled="">Choisir une zone.</mat-option>
                  @for (item of zones; track $index) {<mat-option [value]="item">{{ item }}</mat-option>}
                </mat-select>
                @if (assuranceForm.get('zone')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>N* Attestation</mat-label>
                <input matInput readonly formControlName="attestation" type="text">
                <button matButton matSuffix
                (click)="selectAttestation()"
                [disabled]="attestationList.length == 0"
                [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
                matTooltip="selectionner" >
                  <mat-icon >ink_selection</mat-icon>
                </button>
                @if (assuranceForm.get('attestation')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>

          </div>
          <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" >
                <mat-label>Categorie</mat-label>
                <mat-select
                formControlName="categorie"
                #inputCat
                (valueChange)="onSetType($event)"
                >
                  <mat-option disabled="">Choisir une categorie.</mat-option>
                  @for (item of range(10); track $index) {
                    <!--@if($index+1 == 3){
                      <mat-option [value]="$index+1" [disabled]="inputData.data?.place! > $index+1">categorie {{ $index+1 }}</mat-option>
                    }@else{
                      <mat-option [value]="$index+1">categorie {{ $index+1 }}</mat-option>
                  }-->
                    @if(inputData.data?.remorque && (remorqueCat).includes($index+1)){
                       <mat-option [value]="$index+1">categorie {{ $index+1 }}</mat-option>
                    }@else if(!inputData.data?.remorque) {
                       <mat-option [value]="$index+1">categorie {{ $index+1 }}</mat-option>
                    }
                  }
                </mat-select>
                @if (assuranceForm.get('categorie')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>
              <mat-form-field appearance="outline" >
                <mat-label>Type</mat-label>
                <input matInput readonly
                  formControlName="type_name"/>
                  @if (assuranceForm.get('type')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>N* Carte rose</mat-label>
                <input matInput readonly formControlName="carte_rose" type="text">
                <button matButton matSuffix
                (click)="selectCarteRose()"
                [disabled]="carteRoseList.length == 0"
                [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
                matTooltip="selectionner">
                  <mat-icon >ink_selection</mat-icon>
                </button>
                @if (assuranceForm.get('carte_rose')?.hasError('required')) {<mat-error>Requis</mat-error>}
              </mat-form-field>
          </div>
        </div>
        @switch (inputCat.value) {
            @case (4) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat6">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>

              </div>
            }
            @case (5) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat5">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Est ce un vehicule a usage commercial :  {{ commercial.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    #commercial  formControlName="commercial"
                    (click)="resetDetails(5)"></mat-checkbox>
                  </div>
                </div>
              </div>
            }
            @case (6) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat6">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <mat-form-field>
                  <mat-label>Nbre de carte</mat-label>
                  <input matInput formControlName="nbre_carte" type="number">
                </mat-form-field>
                <hr>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Est ce un vehicule de tarif 1 :  {{ tarif1.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    #tarif1  formControlName="tarif1"
                    (click)="resetDetails(5)"></mat-checkbox>
                  </div>
                </div>
              </div>
            }
            @case (7) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat7">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Vehicule de tourisme :  {{ tourisme.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="utilitaire.checked || deuxTroisRoues.checked"
                    #tourisme  formControlName="tourisme"
                    (click)="resetDetails(7)"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Vehicule utilitaire et taxi  :  {{ utilitaire.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="tourisme.checked || deuxTroisRoues.checked"
                    #utilitaire  formControlName="utilitaire"
                    (click)="resetDetails(7)"></mat-checkbox>
                  </div>

                  <div class="row">
                    <h6 class="col-10">Vehicule de 2 ou 3 roues  :  {{ deuxTroisRoues.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox
                    (change)="updateTypeDoc($event.checked, 'M')"
                    class="col-2"
                    [disabled]="utilitaire.checked || tourisme.checked"
                    #deuxTroisRoues
                    formControlName="deuxTroisRoues"
                    (click)="resetDetails(7)"></mat-checkbox>
                  </div>

                  <hr>
                  <div class="row">
                    <h6 class="col-10">Double Commande ? :  {{ doubleCom.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox
                    class="col-2"
                    [disabled]="deuxTroisRoues.checked"
                    #doubleCom
                    formControlName="doubleCom"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">R.C Eleve ? : {{ rce.checked?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2" #rce  formControlName="rce"></mat-checkbox>
                  </div>
                </div>
              </div>
            }
            @case (8) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat8">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Vehicule de location :  {{ location.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="utilitaire.checked"
                    #location  formControlName="location"
                    (click)="resetDetails(8)"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Vehicule utilitaires  :  {{ utilitaire.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="location.checked"
                    #utilitaire  formControlName="utilitaire"
                    ></mat-checkbox>
                  </div>

                  @if (utilitaire.checked) {
                  <hr>
                  <div class="row">
                    <h6 class="col-10">Moins de 3.5T ? :  {{ moins3_5t.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox
                    class="col-2"
                    [disabled]="plus3_5t.checked"
                    #moins3_5t
                    formControlName="moins3_5t"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Plus de 3.5T ? : {{ plus3_5t.checked?'Oui':'Non' }}</h6>
                    <mat-checkbox
                    class="col-2"
                    #plus3_5t
                    formControlName="plus3_5t"
                    [disabled]="moins3_5t.checked"></mat-checkbox>
                  </div>
                  }
                </div>
              </div>
            }
            @case (9) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat9">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Engin portuaire :  {{ portuaire.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="manutention.checked"
                    #portuaire  formControlName="portuaire"
                    (click)="resetDetails(8)"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Engin de manutention  :  {{ manutention.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="portuaire.checked"
                    #manutention  formControlName="manutention"
                    ></mat-checkbox>
                  </div>
                </div>
              </div>
            }
            @case (10) {
              <div class="col col-md-6 row detailsCategorie" formGroupName="detailsCat10">
                <h3 class="title" >Options de la categorie {{ inputCat.value }}</h3>
                <div class="col-12">
                  <div class="row">
                    <h6 class="col-10">Categorie 10A :  {{ categorie10a.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="collectivite.checked || tracteur.checked"
                    #categorie10a  formControlName="categorie10a"
                    (click)="resetDetails(10)"></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Vehicule de collectivite publique  :  {{ collectivite.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="categorie10a.checked || tracteur.checked"
                    #collectivite  formControlName="collectivite"
                    (click)="resetDetails(10)"
                    ></mat-checkbox>
                  </div>
                  <div class="row">
                    <h6 class="col-10">Tracteur agricole et forestier  :  {{ tracteur.checked ?'Oui':'Non' }}</h6>
                    <mat-checkbox class="col-2"
                    [disabled]="categorie10a.checked || collectivite.checked"
                    #tracteur  formControlName="tracteur"
                    ></mat-checkbox>
                  </div>
                  @if (categorie10a.checked) {
                    <hr>
                    <div class="row">
                      <h6 class="col-10">Ambulance ? :  {{ ambulance.checked ?'Oui':'Non' }}</h6>
                      <mat-checkbox
                      class="col-2"
                      [disabled]="fourgon.checked || corbillard.checked"
                      #ambulance
                      formControlName="ambulance"></mat-checkbox>
                    </div>
                    <div class="row">
                      <h6 class="col-10">Corbillard ? : {{ corbillard.checked?'Oui':'Non' }}</h6>
                      <mat-checkbox
                      class="col-2"
                      #corbillard
                      formControlName="corbillard"
                      [disabled]="fourgon.checked || ambulance.checked"></mat-checkbox>
                    </div>
                    <div class="row">
                      <h6 class="col-10">Fourgon ? : {{ fourgon.checked?'Oui':'Non' }}</h6>
                      <mat-checkbox
                      class="col-2"
                      #fourgon
                      formControlName="fourgon"
                      [disabled]="corbillard.checked || ambulance.checked"></mat-checkbox>
                    </div>
                    <hr>
                    }
                  @if (collectivite.checked) {
                    <hr>
                    <div class="row">
                      <h6 class="col-10">Poids inferieur a 3500 Kg ? :  {{ poidsInferieur.checked ?'Oui':'Non' }}</h6>
                      <mat-checkbox
                      class="col-2"
                      [disabled]="poidsSuperieur.checked"
                      #poidsInferieur
                      formControlName="poidsInferieur"></mat-checkbox>
                    </div>
                    <div class="row">
                      <h6 class="col-10">Poids superieur a 3500 Kg  ? : {{ poidsSuperieur.checked?'Oui':'Non' }}</h6>
                      <mat-checkbox
                      class="col-2"
                      #poidsSuperieur
                      formControlName="poidsSuperieur"
                      [disabled]="poidsInferieur.checked"></mat-checkbox>
                    </div>
                    <hr>
                    }
                </div>
              </div>
            }
        }
        <div class="col-12 col-md-6 row">
          <h3 class="title" >Validite</h3>
          <mat-form-field appearance="outline">
          <mat-label>Date d'effet </mat-label>
          <input
            matInput
            formControlName="date_effet"
            [matDatepicker]="picker"
            placeholder="JJ/MM/AAAA"
            appDateMask
            >
          <mat-hint></mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (assuranceForm.get('date_effet')?.hasError('required')) {<mat-error>Requis</mat-error>}
          @if (assuranceForm.get('date_effet')?.hasError('date')) {<mat-error>Date Invalide, doit etre supérieur ou égale à aujourd'hui</mat-error>}

          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Periode</mat-label>
            <mat-select formControlName="periode" #select (valueChange)="setEndDate($event)">
              <mat-option disabled="">Choisir une periode.</mat-option>
              <mat-option value="60">2 Mois</mat-option>
              <mat-option value="120">4 Mois</mat-option>
              <mat-option value="180">6 Mois</mat-option>
              <mat-option value="240">8 Mois</mat-option>
              <mat-option value="300">10 Mois</mat-option>
              <mat-option value="365">12 Mois</mat-option>
            </mat-select>
            @if (assuranceForm.get('periode')?.hasError('required')) {<mat-error>Requis</mat-error>}
          </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Date de fin</mat-label>
          <input
            [readonly]="true"
            matInput
            formControlName="date_fin"
            [matDatepicker]="pickerEnd"
            placeholder="JJ/MM/AAAA"
            >
          <mat-hint></mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 row">
            <div class="col-12 row">
              <h3 class="title" >Reduction</h3>
              <div class=" m-0 pt-0">
                <div class="row">
                  <div class="col-12">
                    <mat-form-field appearance="outline">
                      <mat-label> Reduction </mat-label>
                      <input matInput formControlName="reduction" type="number" >
                    </mat-form-field>
                  </div>

                </div>
              </div>
            </div>
            @if (!inputData.data?.remorque) {
            <div class="col-12 row">
            <h3 class="title" >Vignette</h3>
            <div class="row">
                <h6 class="col-9">Vignette déjà payé ? : {{ vignette_paye.checked ?'Oui':'Non' }}</h6>
                <mat-checkbox class="col-2" #vignette_paye [disabled]="licence.checked || vignette_exonere.checked" formControlName="vignette_paye"></mat-checkbox>
                  <h6 class="col-9">Exonéré de vignette ? : {{ vignette_exonere.checked ?'Oui':'Non' }}</h6>
                <mat-checkbox class="col-2" #vignette_exonere [disabled]="licence.checked || vignette_paye.checked" formControlName="vignette_exonere"></mat-checkbox>
                <h6 class="col-9">Licence de transport ? : {{ licence.checked ?'Oui':'Non' }}</h6>
                <mat-checkbox class="col-2" #licence [disabled]="vignette_exonere.checked || vignette_paye.checked" formControlName="licence_transport"></mat-checkbox>
            </div>
            </div>
            }
            <div class="col-12 row mt-3" formGroupName="conducteur">
            <h3 class="title" >Conducteur</h3>
            <div class="row">
              <div class="col col-sm-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Nom & Prenom</mat-label>
                    <input matInput formControlName="name" type="text">
                    @if (assuranceForm.get('conducteur')?.get('name')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Date de naissance </mat-label>
                    <input
                      matInput
                      formControlName="birthday"
                      [matDatepicker]="pickerBd"
                      placeholder="JJ/MM/AAAA"
                      appDateMask
                      >
                    <mat-hint></mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerBd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerBd></mat-datepicker>
                    @if (assuranceForm.get('conducteur')?.get('birthday')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Date de delivrance </mat-label>
                    <input
                      matInput
                      formControlName="date_delivrance"
                      appDateMask
                      placeholder="JJ/MM/AAAA"
                      [matDatepicker]="pickerDD"
                      >
                    <mat-hint></mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerDD"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDD></mat-datepicker>
                    @if (assuranceForm.get('conducteur')?.get('date_delivrance')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>
              </div>
              <div class="col col-sm-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Genre</mat-label>
                    <mat-select formControlName="genre">
                      <mat-option disabled="">Choisir.</mat-option>
                      <mat-option value="masculin">Masculin</mat-option>
                      <mat-option value="feminin">Feminin</mat-option>
                    </mat-select>
                     @if (assuranceForm.get('conducteur')?.get('genre')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>N* permis</mat-label>
                    <input matInput formControlName="num_permis" type="text" >
                    @if (assuranceForm.get('conducteur')?.get('num_permis')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Lieu de delivrance</mat-label>
                    <input matInput formControlName="lieu_delivrance" type="text">
                     @if (assuranceForm.get('conducteur')?.get('lieu_delivrance')?.hasError('required')) {<mat-error>Requis</mat-error>}
                  </mat-form-field>
              </div>
            </div>
            </div>
        </div>
        <div class="col-12 col-md-6 row">
            <h3 class="title" >Garanties</h3>
            @if (garantieList().length>0) {<app-list-component [data]="garantieList()" [multi]="true" [page]="6" (Values)="getIdItemList($event)"></app-list-component>}
        </div>

        <!--Garantie details-->
        @if(showDetailsGarantie()){
        <div class="col-12 col-md-6 row" formGroupName="valeurs">
            <h3 class="title">Valeurs Vehicule</h3>
            <div class="row">
              <div class="col col-sm-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Valeur neuve</mat-label>
                    <input matInput formControlName="valeur_neuve" type="number">
                  </mat-form-field>
              </div>
              <div class="col col-sm-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Valeur venale</mat-label>
                    <input matInput formControlName="valeur_venale" type="number">
                  </mat-form-field>
              </div>
            </div>
        </div>
        }

      </div>
    </div>
  <!---->
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close cdkFocusInitial class="bg-mat-red" >Fermer</button>

  <button mat-button class="bg-mat-green" [disabled]="assuranceForm.invalid || saveLoading()" (click)="onConfirmSaveContrat()">
    @if(saveLoading()){
      <mat-spinner diameter="15" matSuffix></mat-spinner>
      Enregistrement ...
    }@else {
      Enregistrer
    }
  </button>

</mat-dialog-actions>

<button matFab extended color="primary" [disabled]="loadingPrevu()" (click)="imprimerAppercu()" [disabled]="assuranceForm.invalid" aria-label="appercu" class="button-absolute" matTooltip="Pre-visualiser" >
  <mat-icon matPrefix>visibility</mat-icon>
  @if(loadingPrevu()){
    <span>Chargement </span>
    <mat-spinner matSuffix [diameter]="20" color="warn"></mat-spinner>
  }@else {
    Pre-visualiser
  }
</button>
<button matFab [hidden]="!windowScrolledTop" (click)="scrollToTop()" aria-label="appercu" class="button-absolute-up" matTooltip="haut" >
  <mat-icon matPrefix>arrow_upward_alt</mat-icon>
</button>
<button matFab [hidden]="!windowScrolledBottom" (click)="scrollToBottom()" aria-label="appercu" class="button-absolute-down" matTooltip="bas" >
  <mat-icon matPrefix>arrow_downward_alt</mat-icon>
</button>
